import { type Address, type AddressDraft } from "@modules/address/addressTypes"
import { EmptyAddress } from "@modules/address/addressUtils"
import { z } from "zod"

export const AddressDtoSchema = z
  .object({
    address: z.string(),
    additionalInformation: z.string().nullable(),
    postalCode: z.string(),
    city: z.string(),
    country: z.string(),
  })
  .meta({ id: "AddressDtoSchema" })

export type AddressDto = z.infer<typeof AddressDtoSchema>

export type AddressDraftDto = AddressDto

export function convertAddressDraftToDto(draft: AddressDraft | undefined): AddressDraftDto {
  const d = draft || EmptyAddress
  return {
    address: d.address,
    additionalInformation: d.additionalInformation ?? "",
    postalCode: d.postalCode,
    city: d.city,
    country: d.country,
  }
}

export function convertAddressFromDto(dto: AddressDto): Address {
  return {
    address: dto.address,
    additionalInformation: dto.additionalInformation ?? "",
    postalCode: dto.postalCode,
    city: dto.city,
    country: dto.country,
  }
}
